var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', _vm._b({}, 'v-sheet', _vm.$attrs, false), [_c('v-date-picker', _vm._b({
    attrs: {
      "show-adjacent-months": "",
      "format": "",
      "event-color": "primary",
      "no-title": "",
      "locale": "en"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }, 'v-date-picker', {
    events: _vm.events,
    weekdayFormat: _vm.weekdayFormat
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }